import React, {useEffect, useState} from 'react';
import {Button, Col, DatePicker, Table, Row, Icon, Tooltip} from "antd";
import {reportService} from "../../../../services/report.services";
import moment from "moment";
import {tableHelper} from "../../../../helpers";
import SelectField from "../../../select-field";
import {distributionCenterService} from "../../../../services";
import i18n from "../../../../i18n";


export default function ReportStatsOrdersDelivery() {

  const [loading, setLoading] = useState(false);
  const [isNeedUpdateReport, setIsNeedUpdateReport] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(true);
  const [errorMsg, setErrorMsg] = useState(null);
  const [searchText, setSearchText] = useState('');

  const [distCenters, setDistCenters] = useState([]);
  const [selectedDistCenters, setSelectedDistCenters] = useState([]);

  // параметры для построения отчета
  const [dateStart, setDateStart] = useState(moment().startOf('month'));
  const [dateEnd, setDateEnd] = useState(moment().endOf('month'));
  // полученные данные отчета
  const [reportData, setReportData] = useState([]);

  // при первом открытии автоматически запрашиваем данные
  useEffect(() => {
    if (loading === false) {
      setLoading(true);
      setIsNeedUpdateReport(true);
      distributionCenterService.getCompanies()
        .then((response) => {
          setDistCenters(response);
        }).catch((errorMsg) => {
        setErrorMsg(errorMsg);
      });
    }
  }, []);

  if (isNeedUpdateReport) {

    // запрос на получение данных отчета
    reportService.getStatsOrdersDelivery(dateStart.format('YYYY-MM-D'), dateEnd.format('YYYY-MM-D'), selectedDistCenters)
      .then((reportData) => {

        const reportDataParsed = reportData.map((item, index) => {
          return {
            userId: item.userId,
            userFio: item.userFio,
            partnerId: item.partnerId,
            partnerName: item.partnerName,
            countCreatedOrders: item.countCreatedOrders,
            countCompletedOrders: item.countCompletedOrders,
            countRefusedOrders: item.countRefusedOrders
          };
        });

        setIsNeedUpdateReport(false);
        setLoading(false);
        setReportData(reportDataParsed);

      }).catch((errorMsg) => {
      setIsNeedUpdateReport(false);
      setLoading(false);
      setErrorMsg(errorMsg);
    });
  }

  // отображение фатальной ошибки
  if (errorMsg) {
    return (<div className="content-error-block">{errorMsg}</div>);
  }

  // список столбцов таблицы
  const columns = [
    {
      title: i18n.t('reportsPage.statsOrdersDelivery.table.userFio.title'),
      dataIndex: 'userFio',
      key: 'userFio',
      width: '35%',
      sorter: (a, b) => {
        return a.userFio.localeCompare(b.userFio);
      },
      ...tableHelper.getColumnSearchProps('userFio', searchText, setSearchText)
    },
    {
      title: i18n.t('reportsPage.statsOrdersDelivery.table.partnerName.title'),
      dataIndex: 'partnerName',
      key: 'partnerName',
      width: '35%',
      ...tableHelper.getColumnSearchProps('partnerName', searchText, setSearchText)
    },
    {
      title: <Tooltip title={i18n.t('reportsPage.statsOrdersDelivery.table.countCreatedOrders.hint')}><span dangerouslySetInnerHTML={{__html:i18n.t('reportsPage.statsOrdersDelivery.table.countCreatedOrders.title')}}/> </Tooltip>,
      dataIndex: 'countCreatedOrders',
      key: 'countCreatedOrders',
      ellipsis: true,
      className: "center"
    },
    {
      title: <Tooltip title={i18n.t('reportsPage.statsOrdersDelivery.table.countCompletedOrders.hint')}><span dangerouslySetInnerHTML={{__html:i18n.t('reportsPage.statsOrdersDelivery.table.countCompletedOrders.title')}}/></Tooltip>,
      dataIndex: 'countCompletedOrders',
      key: 'countCompletedOrders',
      ellipsis: true,
      className: "center"
    },
    {
      title: <Tooltip title={i18n.t('reportsPage.statsOrdersDelivery.table.countRefusedOrders.hint')}><span dangerouslySetInnerHTML={{__html:i18n.t('reportsPage.statsOrdersDelivery.table.countRefusedOrders.title')}}/></Tooltip>,
      dataIndex: 'countRefusedOrders',
      key: 'countRefusedOrders',
      ellipsis: true,
      className: "center"
    },
  ];

  return (
    <React.Fragment>
      <div className="reports__header">
        <h1 className="content-header">{i18n.t('reportsPage.statsOrdersDelivery.title')}</h1>
        <Icon type='filter'
              theme={isFilterOpen ? '' : "filled"}
              onClick={() => {
                setIsFilterOpen(!isFilterOpen)
              }}
              className="reports__filter-toggle"/>
        {isFilterOpen && <div className={`reports__filter ${isFilterOpen ? 'is-open' : ""}`}>
          <Row gutter={12} style={{padding: "0", rowGap: "10px"}} type="flex" justify="start">
            <Col lg={6} md={6} sm={12} xs={24} style={{paddingRight: "10px"}}>
              <DatePicker
                style={{width: "100%"}}
                defaultValue={dateStart}
                format="DD.MM.YYYY"
                size="normal"
                name="dateStart"
                placeholder={i18n.t('reportsPage.statsOrdersDelivery.filter.dateStart.placeholder')}
                allowClear={false}
                onChange={(date) => {
                  setDateStart(date);
                }}
              />
            </Col>
            <Col lg={6} md={6} sm={12} xs={24} style={{paddingRight: "10px"}}>
              <DatePicker
                style={{width: "100%"}}
                defaultValue={dateEnd}
                format="DD.MM.YYYY"
                size="normal"
                name="dateEnd"
                placeholder={i18n.t('reportsPage.statsOrdersDelivery.filter.dateEnd.placeholder')}
                allowClear={false}
                onChange={(date) => {
                  setDateEnd(date);
                }}
              />
            </Col>
            <Col lg={6} md={6} sm={12} xs={24} style={{paddingRight: "10px"}}>
              <SelectField
                name="distributionCenters"
                selectedValue={selectedDistCenters}
                values={distCenters}
                onChange={(value) => {
                  setSelectedDistCenters(value);
                }}
                notFoundText={i18n.t('reportsPage.statsOrdersDelivery.filter.distributionCenters.empty')}
                getErrors={() => {
                }}
                style={{width: "100%"}}
                mode={'multiple'}
              />
            </Col>
            <Col lg={6} md={6} sm={12} xs={24} style={{textAlign: 'right', height: '40px'}}>
              <Button type="primary"
                      htmlType="button"
                      onClick={() => {
                        setLoading(true);
                        setIsNeedUpdateReport(true);
                      }}
                      style={{backgroundColor: '#1CAA53', border: 'none', height: '100%', width: '100%'}}
              >
                {i18n.t('main.buttons.submit')}
              </Button>
            </Col>
          </Row>
        </div>}
      </div>
      <div className="reports__table">
        <div className="reports__table-wrapper">
          <Col span={24}>
              <Table
                style={{minWidth: '100%'}}
                columns={columns}
                dataSource={reportData}
                locale={{emptyText: i18n.t('main.empty')}}
                rowKey={"userId"}
                loading={loading}
                size="small"
                pagination={{pageSize: 50}}
              />

          </Col>
        </div>
      </div>
    </React.Fragment>
  );
}
